const FONT_SANS = 'var(--font-brand)';

/**
 * "Continue with Google" / "Continue with Microsoft".
 *
 * The same button, doing the same thing, on the log-in and sign-up pages: sign
 * in with the provider, and offer to create the account when there is none.
 */
export function SsoButton({
  onClick,
  provider,
  label,
}: {
  onClick: () => void;
  provider: 'google' | 'microsoft';
  label: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="basis-0 border-[#d1d5db] border-solid border bg-white box-border grow min-h-px min-w-px relative rounded-lg shrink-0 hover:bg-gray-50 transition-colors cursor-pointer"
    >
      <div className="flex flex-row items-center justify-center size-full">
        <div className="box-border content-stretch flex gap-[10px] items-center justify-center px-[16px] py-[8px] relative w-full">
          {provider === 'google' ? <GoogleLogo /> : <MicrosoftLogo />}
          <span
            className="text-[14px] text-[#121212]"
            style={{ fontFamily: FONT_SANS }}
          >
            {label}
          </span>
        </div>
      </div>
    </button>
  );
}

export function GoogleLogo({ className = 'size-[24px]' }: { className?: string }) {
  return (
    <svg className={className} aria-hidden="true" fill="none" viewBox="0 0 24 24">
      <path
        fill="#FFC107"
        d="M21.8055 10.0415H21V10H12V14H17.6515C16.827 16.3285 14.6115 18 12 18C8.6865 18 6 15.3135 6 12C6 8.6865 8.6865 6 12 6C13.5295 6 14.921 6.577 15.9805 7.5195L18.809 4.691C17.023 3.0265 14.634 2 12 2C6.4775 2 2 6.4775 2 12C2 17.5225 6.4775 22 12 22C17.5225 22 22 17.5225 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z"
      />
      <path
        fill="#FF3D00"
        d="M3.15302 7.3455L6.43851 9.755C7.32751 7.554 9.48052 6 12 6C13.5295 6 14.921 6.577 15.9805 7.5195L18.809 4.691C17.023 3.0265 14.634 2 12 2C8.15902 2 4.82802 4.1685 3.15302 7.3455Z"
      />
      <path
        fill="#4CAF50"
        d="M12 22C14.583 22 16.93 21.0115 18.7045 19.404L15.6095 16.785C14.5717 17.5742 13.3037 18.001 12 18C9.39903 18 7.19053 16.3415 6.35853 14.027L3.09753 16.5395C4.75253 19.778 8.11353 22 12 22Z"
      />
      <path
        fill="#1976D2"
        d="M21.8055 10.0415H21V10H12V14H17.6515C17.2571 15.1082 16.5467 16.0766 15.608 16.7855L15.6095 16.7845L18.7045 19.4035C18.4855 19.6025 22 17 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z"
      />
    </svg>
  );
}

export function MicrosoftLogo({ className = 'size-[24px]' }: { className?: string }) {
  return (
    <svg className={className} aria-hidden="true" fill="none" viewBox="0 0 24 24">
      <path d="M11.4 3H3v8.4h8.4V3z" fill="#F25022" />
      <path d="M21 3h-8.4v8.4H21V3z" fill="#7FBA00" />
      <path d="M11.4 12.6H3V21h8.4v-8.4z" fill="#00A4EF" />
      <path d="M21 12.6h-8.4V21H21v-8.4z" fill="#FFB900" />
    </svg>
  );
}
